import React from 'react';
import { Section } from './ui/Section';
import { Container } from './ui/Container';
import { ShieldCheckIcon, StarIcon, UsersIcon, FileTextIcon } from 'lucide-react';
export function TrustSection() {
  return <Section background="navy" className="text-white" id="garantia" data-id="element-165">
      <Container data-id="element-166">
        <div className="text-center mb-16" data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-168">
            Nuestro Compromiso
          </h2>
          <p className="text-lg text-brand-cream-100 max-w-2xl mx-auto" data-id="element-169">
            Nos respaldan los resultados. Estos son los números que reflejan la
            confianza de los docentes en nuestros recursos.
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-8 text-center" data-id="element-170">
          <div className="p-4" data-id="element-171">
            <div className="flex justify-center mb-4" data-id="element-172">
              <UsersIcon className="w-10 h-10 text-brand-amber-500" data-id="element-173" />
            </div>
            <div className="text-4xl font-bold mb-2 text-white" data-id="element-174">+500</div>
            <div className="text-brand-cream-100 font-medium" data-id="element-175">
              Docentes Confían en Nosotros
            </div>
          </div>

          <div className="p-4" data-id="element-176">
            <div className="flex justify-center mb-4" data-id="element-177">
              <StarIcon className="w-10 h-10 text-brand-amber-500" data-id="element-178" />
            </div>
            <div className="text-4xl font-bold mb-2 text-white" data-id="element-179">99.9%</div>
            <div className="text-brand-cream-100 font-medium" data-id="element-180">
              Tasa de Satisfacción
            </div>
          </div>

          <div className="p-4" data-id="element-181">
            <div className="flex justify-center mb-4" data-id="element-182">
              <FileTextIcon className="w-10 h-10 text-brand-amber-500" data-id="element-183" />
            </div>
            <div className="text-4xl font-bold mb-2 text-white" data-id="element-184">100%</div>
            <div className="text-brand-cream-100 font-medium" data-id="element-185">
              Contenido Digital
            </div>
          </div>

          <div className="p-4" data-id="element-186">
            <div className="flex justify-center mb-4" data-id="element-187">
              <ShieldCheckIcon className="w-10 h-10 text-brand-amber-500" data-id="element-188" />
            </div>
            <div className="text-4xl font-bold mb-2 text-white" data-id="element-189">7 Días</div>
            <div className="text-brand-cream-100 font-medium" data-id="element-190">
              Garantía de Calidad
            </div>
          </div>
        </div>

        <div className="mt-16 bg-white/5 rounded-2xl p-8 md:p-12 border border-white/10 text-center max-w-4xl mx-auto" data-id="element-191">
          <h3 className="text-2xl font-bold mb-4" data-id="element-192">Calidad Garantizada</h3>
          <p className="text-brand-cream-100 mb-6 max-w-2xl mx-auto" data-id="element-193">
            Todos nuestros materiales pasan por un riguroso proceso de revisión
            pedagógica. Ofrecemos una garantía de 7 días: si experimentas
            problemas técnicos graves o de acceso atribuibles a nuestra
            plataforma, evaluaremos tu caso para un reembolso. Nuestro historial
            de reembolsos es inferior al 0.1%.
          </p>
          <div className="flex items-center justify-center gap-2 text-sm text-brand-cream-100/60" data-id="element-194">
            <ShieldCheckIcon className="w-4 h-4" data-id="element-195" />
            <span data-id="element-196">Operado por TGT FLIP LLC desde Estados Unidos</span>
          </div>
        </div>
      </Container>
    </Section>;
}